export enum SavedFilterType {
  ownershipInstitution = 'OwnershipInstitution',
  peerOwnership = 'PeerOwnership'
}
